import React, { FC } from 'react';

interface Props {
  className?: string;
}

const TemplateStar: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 2.8877L4.8645 5.4222L2 5.9437L4.0075 8.0312L3.624 10.8872L6.25 9.6437L8.8765 10.8877L8.493 8.0312L10.5005 5.9437L7.636 5.4222L6.25 2.8877Z"
        fill="#595D70"
      />
    </svg>
  );
};

export default TemplateStar;
